(() => {
  const dispatch = (name, detail) => {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  };

  document.addEventListener('click', (event) => {
    const action = event.target.closest('[data-tz-card-action]');
    if (!action) return;

    const card = action.closest('[data-tz-product-card]');
    if (!card) return;

    const detail = {
      action: action.dataset.tzCardAction,
      productId: card.dataset.productId || '',
      handle: card.dataset.productHandle || '',
      url: action.getAttribute('href') || action.dataset.productUrl || '',
    };

    if (detail.action === 'quick-add') {
      dispatch('treezyn:card:quick-add', detail);
    } else if (detail.action === 'add') {
      dispatch('treezyn:card:add', detail);
    } else {
      dispatch('treezyn:card:selected', detail);
    }
  });
})();
